import React, { useRef, useEffect } from "react"
import check from "../../images/check-blue.svg"
import downCaret from "../../images/right-caret-dark-blue.svg"

const LanguageDropdownItem = ({
  language,
  currentLanguage,
  handleSelectChange,
  handleKeyPress,
}) => (
  <li
    role="option"
    className="luna-nav-search__language-dropdown__dropdown-item"
    aria-label={`${language?.nativeField} (${language?.translatableName})`}
    tabIndex={0}
  >
    <div className="luna-nav-search__language-dropdown__dropdown-item-icon">
      {language?.nativeField === currentLanguage && (
        <span className="luna-nav-search__language-dropdown__dropdown-item-icon--selected">
          <img src={check} alt="selected language checkmark icon" />
        </span>
      )}
    </div>
    <input
      type="radio"
      id={language?.code}
      name="language"
      tabIndex={0}
      className="luna-nav-search__language-dropdown__dropdown-item-text"
      value={language?.nativeField}
      onClick={e => handleSelectChange(e?.target?.value, language?.code)}
      onKeyDown={e => handleKeyPress(e, language?.nativeField)}
    />
    <label htmlFor={language?.code}>{language?.nativeField}</label>
  </li>
)

const LanguageDropdown = ({
  isOpen,
  languages,
  currentLanguage,
  setCurrentLocale,
  setCurrentLanguage,
  setIsOpen,
  handleToggle,
}) => {
  const dropdownRef = useRef(null)

  // Close dropdown when clicking outside of the dropdown
  useEffect(() => {
    const handleClickOutside = e => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)

    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [dropdownRef, setIsOpen])

  // Set the current language and locale when a language is selected
  const handleSelectChange = (value, locale) => {
    setCurrentLanguage(value)
    setIsOpen(false)
    setCurrentLocale(locale)
  }

  // Set state with Enter key
  const handleKeyPress = (e, callback, value) => {
    if (e.key === "Enter") {
      callback(value)
    }
  }

  return (
    <div className="luna-nav-search__language-dropdown" ref={dropdownRef}>
      <h3 className="luna-nav-search__language-dropdown__title">Language</h3>
      <button
        className="luna-nav-search__language-dropdown__button"
        role="combobox"
        aria-labelledby="select button"
        aria-haspopup="listbox"
        aria-expanded="false"
        aria-controls="select-dropdown"
        onClick={handleToggle}
        style={{ borderBottom: !isOpen ? "1px solid #585C65" : "" }}
      >
        <span className="luna-nav-search__language-dropdown__icon-wrapper">
          <img
            src={downCaret}
            alt="down caret icon"
            className={`luna-nav-search__language-dropdown__icon ${
              isOpen
                ? "luna-nav-search__language-dropdown__icon--caret-up"
                : "luna-nav-search__language-dropdown__icon--caret-down"
            }`}
          />
        </span>
        <span className="luna-nav-search__language-dropdown__selected-value">
          {currentLanguage}
        </span>
      </button>
      {isOpen && (
        <ul
          className={`luna-nav-search__language-dropdown__dropdown ${
            isOpen ? "luna-nav-search__language-dropdown__dropdown--active" : ""
          }`}
        >
          {languages &&
            languages?.length > 0 &&
            languages?.map((language, index) => (
              <LanguageDropdownItem
                key={index}
                language={language}
                currentLanguage={currentLanguage}
                handleSelectChange={handleSelectChange}
                handleKeyPress={handleKeyPress}
              />
            ))}
        </ul>
      )}
    </div>
  )
}

export default LanguageDropdown
